<template>
	<transition name="modal">
		<div>
			<div class="modal-mask">
				<div class="modal-wrapper has-scroll">
					<div class="modal-container" :class="`modal-container-${size}`">
						<div class="modal-header" v-if="$slots.header || !hideHeader">
							<slot name="header">{{ $t('modalHeader') }}</slot>
							<template v-if="!hideClose">
								<slot name="close">
									<div class="modal-close" @click="$emit('close')">
										<i class="material-icons md-36" style="color: #B2101C !important;" v-if="isVoting">highlight_off</i>
										<i class="material-icons" style="color: #606060 !important;" v-else>close</i>
									</div>
									<button type="button" class="close hidden" aria-label="Close" @click="$emit('close')">
										<span aria-hidden="true">&times;</span>
									</button>
								</slot>
							</template>
						</div>

						<div class="modal-body">
							<slot name="body">{{ $t('modalBody') }}</slot>
						</div>

						<div class="modal-footer" v-if="!hideFooter">
							<slot name="footer">
								<button class="btn btn-primary btn-lg raised" @click="$emit('close')">{{ $t('ok') }}</button>
							</slot>
						</div>

						<slot name="custom-footer" v-if="hideCustomFooter"></slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: 'Modal',
	props: {
		size: {
			type: String,
			default: 'small',
		},
		hideHeader: {
			type: Boolean,
			default: false,
		},
		hideFooter: {
			type: Boolean,
			default: false,
		},
		hideClose: {
			type: Boolean,
			default: false,
		},
		hideCustomFooter: {
			type: Boolean,
			default: false,
		},
		isVoting: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onKeyup(event) {
			if (event.key === 'Escape') {
				this.$emit('close');
			}
		},
	},
	created() {
		document.body.classList.add('modal-open');
		window.addEventListener('keyup', this.onKeyup);
	},
	destroyed() {
		document.body.classList.remove('modal-open');
		window.removeEventListener('keyup', this.onKeyup);
	},
};
</script>
